module.exports = __webpack_public_path__ + "img/hooksfishandchips.14e8f6c5.png";